module.exports = __webpack_public_path__ + "static/media/product-6.17c2d0cc.png";